module.exports = __webpack_public_path__ + "img/ic_home_human_body_sensor.020bfadd.png";